import Load from './Load';

export const DefaultLoader = () => {
    return (
        <div className="w-full min-h-[calc(100vh-200px)] flex items-center justify-center">
            <Load />
        </div>
    );
};
